import React from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';

const commonOptions = {
  textAlign: 'center',
  color: 'red',
  fontFamily: 'helvetica, monospace',
  fontWeight: 'bold',
};

// eslint-disable-next-line no-unused-vars
function Whoops({ error, resetErrorBoundary }) {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      position="fixed"
      background="white"
      top={0}
      bottom={0}
      left={0}
      right={0}
    >
      <Box>
        <Text {...commonOptions} fontSize="40px" fontWeight="bold">
          Whoops !!!
        </Text>

        {/* @TEMP-DIAGNOSTIC: show the error on-screen in all envs to capture the
            real render error on mobile devices. Revert this block afterwards. */}
        <Text
          as="pre"
          {...commonOptions}
          textAlign="left"
          fontSize="12px"
          marginTop={8}
          style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxWidth: '90vw' }}
        >
          {String(error?.message || error || 'Unknown error')}
          {'\n\n'}
          {error?.stack || ''}
        </Text>

        <Text {...commonOptions} fontSize="16px" marginTop={4}>
          We are so sorry, but something went wrong.
        </Text>
        {/* @END-TEMP-DIAGNOSTIC */}

        <Flex justifyContent="center" alignItems="center" marginTop={20}>
          <Button variant="darkPrimary" onClick={resetErrorBoundary}>
            Close
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
}

export default Whoops;
